import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface PatientPackageStoreState {
  patientPackageId: number | null;
  setPatientPackageId: (id: number | null) => void;
  clearPatientPackageId: () => void;
}

export const usePatientPackageStore = create<PatientPackageStoreState>()(
  persist(
    (set) => ({
      patientPackageId: null,
      setPatientPackageId: (id) => set({ patientPackageId: id }),
      clearPatientPackageId: () => set({ patientPackageId: null }),
    }),
    {
      name: 'patient-package-store', // unique name for localStorage key
    }
  )
);
